import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import Card from '@/pages/Tbqy/components/components/Card'
import FullTable from '@/components/FullTable'
import * as api from '@/api/tbyqy'
import styles from '@/pages/Tbqy/style.module.less'

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

type TabsPropType = FC<PropsWithChildren<{
  onChange?: (val: string) => void
}>>

const Tabs: TabsPropType = ({onChange}) => {
  const [items, setItems] = useState([
    {label: '待收回合同', value: 0, key: 'ljdhshtlist', totalKey: 'ljdhshtnumList'},
    {label: '本年已发合同', value: 0, key: 'bnyfchtlist', totalKey: 'bnyfchtnumList'},
    {label: '本年已收回合同', value: 0, key: 'bnyshhtlist', totalKey: 'bnyshhtnumList'},
  ])
  const [active, setActive] = useState('ljdhshtlist')

  const handleActive = useCallback((item) => {
    setActive(item.key)
  }, [])
  
  useEffect(() => {
    if(typeof onChange === 'function') {
      onChange(active)
    }

  }, [onChange, active])

  const getData = useCallback(async () => {
    const res = await api.getBndsfhttj()
    if(res.success) {
      const data = res.data || {}
      for(let i=0; i<items.length; i++) {
        items[i].value = data[items[i].totalKey] || 0
      }
      setItems([...items])
    }
  }, [items])

  useEffect(() => {
    getData()
  }, [])

  return (
    <div>
      {
        items.map(item => (
          <div key={item.key} className={`ptb-20 plr-20 cursor-pointer ${active === item.key && styles.active} ${styles['bndsfht-left-tab-item']}`} onClick={() => handleActive(item)}>
            <div className='text-777'>{item.label}</div>
            <div className='flex align-center primary-color font-20'>
              <div className='font-33 font-700 mr-6'>{item.value}</div>
              <CaretRightOutlined />
            </div>
          </div>
        ))
      }
    </div>
  )
}

const Index: PropType = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  const getData = useCallback(async (type) => {
    setLoading(true)
    const res = await api.getBndsfhttjmx(type).finally(() => {
      setLoading(false)
    })
    if(res.success) {
      setData(res.data.list || [])
    }
  }, [])

  return (
    <Spin spinning={loading}>
      <Card title="收发合同统计">
        <div  className={`flex`} style={{height: '350px'}}>
          <Tabs onChange={getData} />
          <div className='flex-1 w-0 ml-10'>
            <FullTable
              rowKey="HTBH"
              columns={
                [
                  {title: '合同编号', width: '50%', dataIndex: 'HTBH', ellipsis: true},
                  {title: '合同名称', width: '80%', dataIndex: 'HTMC', ellipsis: true},
                  {title: '项目名称', width: '80%', dataIndex: 'XMMC', ellipsis: true},
                  {title: '业务负责人', width: '40%', dataIndex: 'XMFZR', ellipsis: true},
                  {title: '预计项目启动时间', width: '50%', dataIndex: 'YJQDSJ', ellipsis: true},
                  {title: '委托方', width: '50%', dataIndex: 'KHMC', ellipsis: true},
                  {title: '服务内容', width: '50%', dataIndex: 'FWNR', ellipsis: true},
                ]
              }
              dataSource={data}
            />
          </div>
        </div>
      </Card>
    </Spin>
  )
}

export default Index
